import { ref } from "@vue/composition-api";

export default function useReorderTable() {
  const keyChange = ref(0);
  const currentIndex = ref(null);
  const currentIdSelect = ref(null);
  const tableModeReorder = ref(false);

  const sortableRowOptions = ref({
    chosenClass: "is-selected",
    ghostClass: "sortable-ghost",
    onEnd: () => {},
    disabled: true,
    animation: 300,
    easing: "cubic-bezier(0.22, 1, 0.36, 1)",
  });

  return {
    keyChange,
    currentIndex,
    currentIdSelect,
    tableModeReorder,
    sortableRowOptions,
  };
}
